import { Component, Input, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';
import { ControlValueAccessor, NgControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';

@Component({
    selector: 'web-radio-input',
    imports: [IonicModule, ReactiveFormsModule, FormsModule],
    templateUrl: './radio-input.component.html',
    styleUrl: './radio-input.component.scss',
})
export class RadioInputComponent extends AbstractComponentMobile implements ControlValueAccessor {
    protected controlDir = inject(NgControl, { self: true, optional: true });

    public override tag = '[RadioInputComponent]';

    @Input() options: { label: string; value: string; disabled?: boolean }[] = [];

    private onChange: (value: any) => void = () => {};
    private onTouched: () => void = () => {};
    public value = '';

    constructor() {
        super();
        if (this.controlDir) {
            this.controlDir.valueAccessor = this;
        }
    }

    onInputChanged(event: Event) {
        const input = (event.target as HTMLInputElement).value;
        this.value = input;
        this.onChange(input);
    }

    writeValue(value: string): void {
        this.value = value;
    }

    registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        // Implement if needed
    }

    onValueChange(value: string): void {
        this.value = value;
        this.onChange(value);
        this.onTouched();
    }
}
